import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";

export const useFetchMaintenanceNotification = (
  page: number,
  pageSize: number,
  filterParams: any,
) => {
  const companyId = getCompanyId();
  const { __BLOCK_API__, ...restFilterParams } = filterParams || {};
  return useQuery(
    [QUERY_NAME.MAINTENANCE_NOTICES, restFilterParams, page, pageSize],
    () =>
      axios({
        method: "get",
        url: SERVICES.MAINTENANCE_NOTICES,
        params: {
          ...restFilterParams,
          page: page,
          per_page: pageSize,
          current_company_id: companyId,
        },
      }).then((res) => ({
        data: res.data,
        meta: {
          total: res.headers["x-total"] || 0,
          total_page: res.headers["x-total-pages"] || 0,
        },
      })),
    { staleTime: Infinity, enabled: !__BLOCK_API__ },
  );
};

export const useFetchMaintenanceNoticeFilterOptions = (
  payload: any,
  enabled: boolean,
) => {
  const companyId = getCompanyId();
  return useQuery(
    [QUERY_NAME.MAINTENANCE_NOTICES, "filter_options", payload],
    () =>
      axios({
        method: "post",
        url: `${SERVICES.MAINTENANCE_NOTICES}/filter_options`,
        data: {
          ...payload,
          current_company_id: companyId,
        },
      }).then((res) => res.data),
    {
      enabled,
      cacheTime: 5 * 60 * 1000,
      staleTime: 5 * 60 * 1000,
    },
  );
};

export const useDeleteMultipleMaintenanceNotification = () => {
  const queryClient = useQueryClient();
  const companyId = getCompanyId();
  return useMutation(
    ({ listIds }: any) => {
      const formData = new FormData();
      listIds.forEach((id: any) => {
        formData.append(`delete_ids[]`, id);
      });
      formData.append("current_company_id", companyId.toString());
      return axios({
        method: "post",
        data: formData,
        url: `${SERVICES.MAINTENANCE_NOTICES}/delete_multiple`,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.ANNUAL_SUMMERIES]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};
